'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('../styles/ScreenReaderShortcuts.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScreenReaderShortcuts = function ScreenReaderShortcuts(_ref) {
  var screenReaderNavigation = _ref.screenReaderNavigation;
  return _react2.default.createElement(
    'div',
    { className: 'cp-screen-reader-shortcuts' },
    _react2.default.createElement('div', {
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML: { __html: screenReaderNavigation } }),
    _react2.default.createElement(
      'a',
      { href: '#content', className: 'screen_reader_nav' },
      'Skip to Content'
    )
  );
};

ScreenReaderShortcuts.displayName = 'ScreenReaderShortcuts';
ScreenReaderShortcuts.propTypes = {
  screenReaderNavigation: _react.PropTypes.string.isRequired
};

exports.default = ScreenReaderShortcuts;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-screen-reader-shortcuts/lib/components/ScreenReaderShortcuts.components.js
// module id = 1343
// module chunks = 1